import { ForgotComponent } from './components/forgot/forgot.component';
import { LoginComponent } from './components/login/login.component';
import { SharedModule } from './modules/shared.module';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { JwtInterceptor } from './helpers/jwt.interceptor';
import { BrowserModule } from '@angular/platform-browser';
import { Injector, NgModule } from '@angular/core';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { IconSetService } from '@coreui/icons-angular';
import { AppComponent } from './app.component';

// Import containers
import { DefaultLayoutComponent } from './containers';

const APP_CONTAINERS = [
  DefaultLayoutComponent
];

import {
  AppAsideModule,
  AppBreadcrumbModule,
  AppHeaderModule,
  AppFooterModule,
  AppSidebarModule,
} from '@coreui/angular';

// Import routing module
import { AppRoutingModule } from './app.routing';

// Import 3rd party components
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { RegisterComponent } from './components/register/register.component';
import { ErrorComponent } from './components/error/error.component';
import { ProfileComponent } from './components/profile/profile.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { PasswordChangedSuccessComponent } from './components/change-password/password-changed-success/password-changed-success.component';
import { ToastrModule } from 'ngx-toastr';

// import ngx-translate and the http loader
import { HelpComponent } from './components/help/help.component';
import { AddVersionsComponent } from './components/help/add-versions/add-versions.component';
import { CanDeactivateAddDocuments } from './helpers/canDeactivateAddDocuments.guard';
import { ManageAuthorizationsComponent } from './components/authorizations/manage-authorizations/manage-authorizations.component';
import { ManageLicensesComponent } from './components/licenses/manage-licenses/manage-licenses.component';
import { ReportCompaniesComponent } from './components/report-companies/report-companies.component';
import { SwalComponentComponent } from './components/swal-component/swal-component.component';
import { CompanyProductComponent } from './components/core/company-products/company-products.component';
import { ListNotificationsComponent } from './components/notifications/list-notifications/list-notifications.component';
import { MynamirialbindingComponent } from './components/login/mynamirialbinding/mynamirialbinding.component';
import { InvoiceCounterComponent } from './components/invoice-counters/invoice-counter.component';




// required for AOT compilation
// export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
//   return new TranslateHttpLoader(http);
// }

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AppAsideModule,
    AppBreadcrumbModule.forRoot(),
    AppFooterModule,
    AppHeaderModule,
    HttpClientModule,        
    AppSidebarModule,
    BsDropdownModule.forRoot(),
    TabsModule.forRoot(),
    SharedModule.forRoot(),
    // ngx-translate and the loader module
    // TranslateModule.forRoot({
    //   loader: {
    //     provide: TranslateLoader,
    //     useFactory: HttpLoaderFactory,
    //     deps: [HttpClient]
    //   }
    // }),
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right'
    })
  ],
  declarations: [
    AppComponent,
    ...APP_CONTAINERS,
    LoginComponent,
    RegisterComponent,
    SpinnerComponent,
    ForgotComponent,
    ErrorComponent,
    ProfileComponent,
    ChangePasswordComponent,
    PasswordChangedSuccessComponent,
    HelpComponent,
    AddVersionsComponent,
    ManageAuthorizationsComponent,
    ManageLicensesComponent,
    ReportCompaniesComponent,
    CompanyProductComponent,
    SwalComponentComponent,
    ListNotificationsComponent,
    MynamirialbindingComponent,
    InvoiceCounterComponent    
  ],
  providers: [
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },    
    IconSetService,
    CanDeactivateAddDocuments
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(private injector: Injector) {
    InjectorInstance = this.injector;
  }
}

export let InjectorInstance: Injector;
